import React from 'react';
import { Tabs, TabsContent, TabsList, TabsTrigger } from '../components/ui/tabs';
import { Card, CardContent } from '../components/ui/card';

const Legal = () => {
  return (
    <div className="min-h-screen">
      {/* Hero Section */}
      <section className="bg-[#1B4D40] py-16 md:py-20">
        <div className="container mx-auto px-4 sm:px-6 lg:px-8 text-center">
          <h1 className="text-4xl md:text-5xl font-bold text-white mb-4">
            Legal Information
          </h1>
          <p className="text-lg md:text-xl text-gray-200 max-w-2xl mx-auto">
            Privacy Policy & Terms of Service
          </p>
        </div>
      </section>

      {/* Main Content */}
      <section className="py-16 md:py-20">
        <div className="container mx-auto px-4 sm:px-6 lg:px-8">
          <Tabs defaultValue="privacy" className="max-w-5xl mx-auto">
            <TabsList className="grid w-full max-w-2xl mx-auto grid-cols-2 mb-8 h-auto">
              <TabsTrigger
                value="privacy"
                className="py-3 data-[state=active]:bg-[#C0D8A3] data-[state=active]:text-white"
              >
                Privacy Policy
              </TabsTrigger>
              <TabsTrigger
                value="terms"
                className="py-3 data-[state=active]:bg-[#C0D8A3] data-[state=active]:text-white"
              >
                Terms of Service
              </TabsTrigger>
            </TabsList>

            {/* Privacy Policy */}
            <TabsContent value="privacy">
              <Card>
                <CardContent className="p-8 space-y-6">
                  <div>
                    <p className="text-sm text-gray-500 mb-4">
                      Last Updated: December 2025
                    </p>
                    <h2 className="text-2xl font-bold text-[#1B4D40] mb-4">
                      Privacy Policy
                    </h2>
                    <p className="text-[#2C3E50] leading-relaxed">
                      Green Coke and Energy Pvt. Ltd. ("we," "our," or "us") is
                      committed to protecting your privacy. This Privacy Policy
                      explains how we collect, use, disclose, and safeguard your
                      information when you visit our website or use our
                      services.
                    </p>
                  </div>

                  <div>
                    <h3 className="text-xl font-bold text-[#1B4D40] mb-3">
                      1. Information We Collect
                    </h3>
                    <p className="text-[#2C3E50] leading-relaxed mb-3">
                      We may collect personal information that you voluntarily
                      provide to us when you:
                    </p>
                    <ul className="list-disc pl-6 space-y-2 text-[#2C3E50]">
                      <li>
                        Fill out contact forms or inquiry forms on our website
                      </li>
                      <li>Subscribe to our newsletter or updates</li>
                      <li>Request product information or quotations</li>
                      <li>Communicate with us via email or phone</li>
                    </ul>
                    <p className="text-[#2C3E50] leading-relaxed mt-3">
                      The personal information we collect may include your name,
                      email address, phone number, company name, industry, and
                      any other information you choose to provide.
                    </p>
                  </div>

                  <div>
                    <h3 className="text-xl font-bold text-[#1B4D40] mb-3">
                      2. How We Use Your Information
                    </h3>
                    <p className="text-[#2C3E50] leading-relaxed mb-3">
                      We use the information we collect to:
                    </p>
                    <ul className="list-disc pl-6 space-y-2 text-[#2C3E50]">
                      <li>
                        Respond to your inquiries and provide requested
                        information
                      </li>
                      <li>
                        Process and fulfill your requests for products or
                        services
                      </li>
                      <li>
                        Send you updates, newsletters, and marketing
                        communications (with your consent)
                      </li>
                      <li>Improve our website and services</li>
                      <li>Comply with legal obligations</li>
                    </ul>
                  </div>

                  <div>
                    <h3 className="text-xl font-bold text-[#1B4D40] mb-3">
                      3. Information Sharing and Disclosure
                    </h3>
                    <p className="text-[#2C3E50] leading-relaxed">
                      We do not sell, trade, or rent your personal information
                      to third parties. We may share your information with
                      trusted service providers who assist us in operating our
                      website and conducting our business, provided they agree
                      to keep this information confidential. We may also
                      disclose your information when required by law or to
                      protect our rights.
                    </p>
                  </div>

                  <div>
                    <h3 className="text-xl font-bold text-[#1B4D40] mb-3">
                      4. Data Security
                    </h3>
                    <p className="text-[#2C3E50] leading-relaxed">
                      We implement appropriate technical and organizational
                      security measures to protect your personal information
                      against unauthorized access, alteration, disclosure, or
                      destruction. However, no method of transmission over the
                      Internet or electronic storage is 100% secure.
                    </p>
                  </div>

                  <div>
                    <h3 className="text-xl font-bold text-[#1B4D40] mb-3">
                      5. Your Rights
                    </h3>
                    <p className="text-[#2C3E50] leading-relaxed mb-3">
                      You have the right to:
                    </p>
                    <ul className="list-disc pl-6 space-y-2 text-[#2C3E50]">
                      <li>Access the personal information we hold about you</li>
                      <li>Request correction of inaccurate information</li>
                      <li>Request deletion of your personal information</li>
                      <li>Opt-out of marketing communications</li>
                      <li>
                        Withdraw consent for data processing (where applicable)
                      </li>
                    </ul>
                  </div>

                  <div>
                    <h3 className="text-xl font-bold text-[#1B4D40] mb-3">
                      6. Cookies and Tracking
                    </h3>
                    <p className="text-[#2C3E50] leading-relaxed">
                      Our website may use cookies and similar tracking
                      technologies to enhance your browsing experience. You can
                      control cookie preferences through your browser settings.
                    </p>
                  </div>

                  <div>
                    <h3 className="text-xl font-bold text-[#1B4D40] mb-3">
                      7. Changes to This Policy
                    </h3>
                    <p className="text-[#2C3E50] leading-relaxed">
                      We may update this Privacy Policy from time to time. We
                      will notify you of any changes by posting the new Privacy
                      Policy on this page with an updated "Last Updated" date.
                    </p>
                  </div>

                  <div>
                    <h3 className="text-xl font-bold text-[#1B4D40] mb-3">
                      8. Contact Us
                    </h3>
                    <p className="text-[#2C3E50] leading-relaxed">
                      If you have any questions about this Privacy Policy or our
                      data practices, please contact us at:
                    </p>
                    <p className="text-[#2C3E50] mt-3">
                      Email:{' '}
                      <a
                        className="text-[#2C3E50] mt-3"
                        href="mailto:info@greencokeenergy.com"
                      >
                        info@greencokeenergy.com
                      </a>
                    </p>
                    <p className="text-[#2C3E50] mt-1">
                      Phone: <a href="tel:+919176651276"> +919176651276</a>
                    </p>
                  </div>
                </CardContent>
              </Card>
            </TabsContent>

            {/* Terms of Service */}
            <TabsContent value="terms">
              <Card>
                <CardContent className="p-8 space-y-6">
                  <div>
                    <p className="text-sm text-gray-500 mb-4">
                      Last Updated: December 2025
                    </p>
                    <h2 className="text-2xl font-bold text-[#1B4D40] mb-4">
                      Terms of Service
                    </h2>
                    <p className="text-[#2C3E50] leading-relaxed">
                      Welcome to Green Coke and Energy Pvt. Ltd. These Terms of
                      Service ("Terms") govern your use of our website and
                      services. By accessing or using our website, you agree to
                      be bound by these Terms.
                    </p>
                  </div>

                  <div>
                    <h3 className="text-xl font-bold text-[#1B4D40] mb-3">
                      1. Use of Website
                    </h3>
                    <p className="text-[#2C3E50] leading-relaxed mb-3">
                      You may use our website for lawful purposes only. You
                      agree not to:
                    </p>
                    <ul className="list-disc pl-6 space-y-2 text-[#2C3E50]">
                      <li>
                        Use the website in any way that violates applicable laws
                        or regulations
                      </li>
                      <li>
                        Attempt to gain unauthorized access to our systems or
                        networks
                      </li>
                      <li>Transmit any harmful or malicious code</li>
                      <li>Interfere with or disrupt the website or servers</li>
                    </ul>
                  </div>

                  <div>
                    <h3 className="text-xl font-bold text-[#1B4D40] mb-3">
                      2. Intellectual Property
                    </h3>
                    <p className="text-[#2C3E50] leading-relaxed">
                      All content on this website, including text, graphics,
                      logos, images, and software, is the property of Green Coke
                      and Energy Pvt. Ltd. or its licensors and is protected by
                      copyright and other intellectual property laws. You may
                      not reproduce, distribute, or create derivative works
                      without our express written permission.
                    </p>
                  </div>

                  <div>
                    <h3 className="text-xl font-bold text-[#1B4D40] mb-3">
                      3. Product Information and Availability
                    </h3>
                    <p className="text-[#2C3E50] leading-relaxed">
                      We strive to provide accurate information about our
                      products and services. However, we are currently in our
                      commissioning phase, and product availability is subject
                      to change. All product specifications and timelines are
                      subject to confirmation. We reserve the right to modify
                      product offerings without prior notice.
                    </p>
                  </div>

                  <div>
                    <h3 className="text-xl font-bold text-[#1B4D40] mb-3">
                      4. Disclaimer of Warranties
                    </h3>
                    <p className="text-[#2C3E50] leading-relaxed">
                      This website and its content are provided "as is" without
                      any warranties of any kind, either express or implied. We
                      do not warrant that the website will be uninterrupted,
                      error-free, or free of viruses or other harmful
                      components.
                    </p>
                  </div>

                  <div>
                    <h3 className="text-xl font-bold text-[#1B4D40] mb-3">
                      5. Limitation of Liability
                    </h3>
                    <p className="text-[#2C3E50] leading-relaxed">
                      To the fullest extent permitted by law, Green Coke and
                      Energy Pvt. Ltd. shall not be liable for any indirect,
                      incidental, special, consequential, or punitive damages
                      arising from your use of the website or our services.
                    </p>
                  </div>

                  <div>
                    <h3 className="text-xl font-bold text-[#1B4D40] mb-3">
                      6. Third-Party Links
                    </h3>
                    <p className="text-[#2C3E50] leading-relaxed">
                      Our website may contain links to third-party websites. We
                      are not responsible for the content, privacy practices, or
                      terms of service of these external sites.
                    </p>
                  </div>

                  <div>
                    <h3 className="text-xl font-bold text-[#1B4D40] mb-3">
                      7. Governing Law
                    </h3>
                    <p className="text-[#2C3E50] leading-relaxed">
                      These Terms shall be governed by and construed in
                      accordance with the laws of India. Any disputes arising
                      from these Terms shall be subject to the exclusive
                      jurisdiction of the courts in Mumbai, Maharashtra.
                    </p>
                  </div>

                  <div>
                    <h3 className="text-xl font-bold text-[#1B4D40] mb-3">
                      8. Changes to Terms
                    </h3>
                    <p className="text-[#2C3E50] leading-relaxed">
                      We reserve the right to modify these Terms at any time.
                      Changes will be effective immediately upon posting to the
                      website. Your continued use of the website after changes
                      are posted constitutes your acceptance of the modified
                      Terms.
                    </p>
                  </div>

                  <div>
                    <h3 className="text-xl font-bold text-[#1B4D40] mb-3">
                      9. Contact Information
                    </h3>
                    <p className="text-[#2C3E50] leading-relaxed">
                      If you have any questions about these Terms, please
                      contact us at:
                    </p>
                    <p className="text-[#2C3E50] mt-3">
                      Green Coke and Energy Pvt. Ltd.
                    </p>
                    <p className="text-[#2C3E50] mt-1">
                      Email:{' '}
                      <a href="mailto:info@greencokeenergy.com">
                        info@greencokeenergy.com
                      </a>
                    </p>
                    <p className="text-[#2C3E50] mt-1">
                      Phone: <a href="tel:+919176651276"> +919176651276</a>
                    </p>
                  </div>
                </CardContent>
              </Card>
            </TabsContent>
          </Tabs>
        </div>
      </section>
    </div>
  );
};

export default Legal;